<div class="full-page-loading-root">
  <app-epson-logo [animate]="true"></app-epson-logo>
</div>
